import { flow } from "fp-ts/lib/function";

import { type Discoverability } from "../../gql-generated/types";
import { type GetLensInfoResponse } from "../../lens/api/queries";

const updateDiscoverability =
    (tags?: readonly string[]) =>
    (discoverabilityDraft: Discoverability): Discoverability => {
        if (!tags) return discoverabilityDraft;

        return {
            ...discoverabilityDraft,
            tagsList: [...tags],
        };
    };
const updateLensDiscoverabilityLocations =
    (locations?: readonly string[]) =>
    (discoverabilityDraft: Discoverability): Discoverability => {
        if (!locations) return discoverabilityDraft;

        return {
            ...discoverabilityDraft,
            locationsList: [...locations],
        };
    };
const updateLensDiscoverabilityDaysTimesHolidays =
    (daysTimesHolidays?: readonly string[]) =>
    (discoverabilityDraft: Discoverability): Discoverability => {
        if (!daysTimesHolidays) return discoverabilityDraft;

        return {
            ...discoverabilityDraft,
            daysTimesHolidaysList: [...daysTimesHolidays],
        };
    };

// This helper method needed to remove __typename property that is not expected
// when a mutation sent to GraphQL layer
export const makeDiscoverabilityForUpdate = (lensForUpdate: GetLensInfoResponse): Discoverability | null => {
    if (lensForUpdate.lens?.discoverability) {
        const { tagsList, description, locationsList, daysTimesHolidaysList } = lensForUpdate.lens.discoverability;
        return flow(
            updateDiscoverability(tagsList ?? undefined),
            updateLensDiscoverabilityLocations(locationsList ?? undefined),
            updateLensDiscoverabilityDaysTimesHolidays(daysTimesHolidaysList ?? undefined),
        )({ tagsList, description, locationsList, daysTimesHolidaysList });
    }
    return null;
};
